export default {
  id: "page18",

  questions: [
    {
      type: "justlabel",
      number: "28",
      label:
        "Palenie papierosów i picie kawy zaburza ocenę produktów. Jeżeli pali Pan(i) papierosy i / lub pije kawę, chcielibyśmy bardzo prosić Pana(ią), aby przynajmniej godzinę przed testem nie palił(a) Pan(i) papierosów, ani nie pił(a) kawy. ",
      info: "<strong>Proszę zaznaczyć jedną wybraną odpowiedź.</export>"
    },

    {
      label:
        "Czy zgadza się Pan(i) na to, aby przez godzinę przed przeprowadzanym testem powstrzymać się od palenia papierosów i / lub picia kawy? Jeżeli w ogóle nie pali Pan(i) papierosów, ani nie pije kawy, proszę wybrać odpowiedź TAK. ",

      type: "radio",
      id: "ankieta_zgodaKawa",
      required: true,
      labelStrong: false,
      columns: true,
      labelWidth: "is-three-fifths",
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },

    {
      type: "select",
      label:
        "Skąd dowiedział(a) się Pan(i) o naszej Pracowni Analizy Sensorycznej?",
      id: "ankieta_skadInfo",
      required: true,
      labelWidth: "is-three-fifths",
      options: [
        { value: "", name: "" },
        { value: "strona", name: "Strona internetowa naszej firmy" },
        { value: "facebook", name: "Facebook" },
        { value: "ulotka", name: "Ulotka" },
        { value: "rodzina", name: "Od rodziny, znajomych" },
        { value: "inne", name: "Inne" }
      ],
      number: "29"
    },
      {
      type: "justlabel",
      number: "30",
      label: "Alergie / nietolerancje pokarmowe"
    },
    {
      label:
        "Czy cierpi Pan(i) na jakiekolwiek alergie / nietolerancje pokarmowe?",

      type: "radio",
      id: "ankieta_czyAlergie",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      type: "justlabel",
      info:
        "Proszę zaznaczyć jakie",
      show: [["ankieta_czyAlergie", "==='1'"]],
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      topLine: true,
      labelWidth: "is-three-fifths",
      bottomLine: true,
      show: [["ankieta_czyAlergie", "==='1'"]],
    },
    {
      label: "Zboża i wyroby zawierające gluten",
      type: "radio",
      id: "alergeny_gluten",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Skorupiaki i produkty podobne",
      type: "radio",
      id: "alergeny_skorupiaki",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Jaja i produkty pochodne",
      type: "radio",
      id: "alergeny_jaja",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Ryby i produkty pochodne",
      type: "radio",
      id: "alergeny_ryby",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Orzeszki ziemne i produkty pochodne",
      type: "radio",
      id: "alergeny_orzeszkiZiemne",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Soja i produkty pochodne",
      type: "radio",
      id: "alergeny_soja",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Mleko i produkty pochodne (laktoza)",
      type: "radio",
      id: "alergeny_laktoza",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Seler i produkty pochodne",
      type: "radio",
      id: "alergeny_seler",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Gorczyca i produkty pochodne",
      type: "radio",
      id: "alergeny_gorczyca",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Sezam i produkty pochodne",
      type: "radio",
      id: "alergeny_sezam",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "SO2 i siarczan > 10 mg/kg",
      type: "radio",
      id: "alergeny_siarczan",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Łubin i produkty pochodne",
      type: "radio",
      id: "alergeny_lubin",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Mięczaki i produkty pochodne",
      type: "radio",
      id: "alergeny_mieczaki",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }],
      show: [["ankieta_czyAlergie", "==='1'"]]
    },
    {
      label: "Inne",
      id: "alergeny_inne",
      required: false,
      labelWidth: "is-three-fifths",
      show: [["ankieta_czyAlergie", "==='1'"]],
      columns: true,
      validations: {maxLength: 50 },
      labelStrong: false,
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page18.js